import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { REFRESH_TOKEN_URL } from '../api/urls';

const Session: React.FC = () => {
  const { token, setToken, setIsInitializing } = useAuth() as any;
  const navigate = useNavigate();
  const location = useLocation();
  const attemptedRef = React.useRef(false);

  React.useEffect(() => {
    if (attemptedRef.current) return;
    attemptedRef.current = true;

    const tryRefresh = async () => {
      try {
        if (token) return;
        const res = await fetch(REFRESH_TOKEN_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        });
        if (!res.ok) {
          return;
        }
        const json = await res.json();
        const access = json?.access as string | undefined;
        if (!access) {
          return;
        }
        setToken(access);
      } catch {
      } finally {
        setIsInitializing(false);
      }
    };

    tryRefresh();
  }, [token, setToken, setIsInitializing, navigate, location]);

  return null;
};

export default Session; 